module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/digital-realities-vr-colony-square.json
// module id = 424
// module chunks = 259672565134947